import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://react-burger-builder-6405c.firebaseio.com/'
});

export default instance;